<script setup lang="ts">
defineSlots<{ default: () => unknown }>();
</script>
<template>
  <main class="min-h-dvh px-4 py-26 md:py-52">
    <slot name="default"></slot>
  </main>
</template>
